export const APP_NAMES = [
  'tangeringe-app--santillana',
  'tangeringe-app--compartirbrasil',
  'tangeringe-app--compartircolombia',
  'tangeringe-app--unoibrasil',
  'tangeringe-app--unoicolombia',
  'tangeringe-app--sumun',
  'tangeringe-app--multitenant',
  'EDP-app',
];

export const timesUnitIds = {
  annually: 'Annually',
  semiannually: 'Semi-annually',
  quarterly: 'Quarterly',
  bimonthly: 'Bimonthly',
};

export const timesUnitLenthIds = {
  1: 'Annually',
  2: 'Semi-annually',
  3: 'Quarterly',
  4: 'Bimonthly',
};

export const timesUnit = [
  {
    name: timesUnitIds.quarterly,
    periods: [
      { name: 'Quarter 1', id: 'quarter1' },
      { name: 'Quarter 2', id: 'quarter2' },
      { name: 'Quarter 3', id: 'quarter3' },
    ],
  },
  {
    name: timesUnitIds.bimonthly,
    periods: [
      { name: 'Bimester 1', id: 'bimester1' },
      { name: 'Bimester 2', id: 'bimester2' },
      { name: 'Bimester 3', id: 'bimester3' },
      { name: 'Bimester 4', id: 'bimester4' },
    ],
  },
  {
    name: timesUnitIds.semiannually,
    periods: [
      { name: 'Semester 1', id: 'semester1' },
      { name: 'Semester 2', id: 'semester2' },
    ],
  },
  { name: timesUnitIds.annually, periods: [{ name: 'School year', id: 'Annually' }] },
];

export const PERIOD_MAPPING = {
  trimestral: 'Quarterly',
  quatrimestral: 'Semi-annually',
  bimensual: 'Bimonthly',
  anual: 'Annually',
};

export const LTI_CONTENT_TYPES = {
  AUDIO: 'audio',
  DOCUMENT: 'document',
  VIDEO: 'video',
  HTML: 'html',
  PDF: 'pdf',
  PPT: 'ppt',
  EXCEL: 'excel',
  DOCX: 'docx',
};

export const typeContentsIcons = {
  CTTY_00: 'doc',
  CTTY_01: 'fixed-layout',
  CTTY_03: 'video',
  CTTY_04: 'audio',
  CTTY_05: 'pdf',
  CTTY_06: 'link-content',
  CTTY_07: 'image',
  CTTY_08: 'task',
  CTTY_09: 'questionary',
  CTTY_10: 'task',
  CTTY_13: 'zip',
  CTTY_14: 'task',
  CTTY_12: 'pdf',
  CTTY_20: 'xapi',
  CTTY_VIDEOLESSON: 'videolesson',
  CTTY_PLENO: 'pleno',
  CTTY_PLENO_DRAFT: 'pleno-white',
  CTTY_MINTBLOCK: 'mint-post',
  MINT_PAGE: 'mint-post',
  MINT_PAGE_DUAL: 'mint-post',
  questionary: 'questionary',
  test: 'questionary',
  videolesson: 'video-camera',
};

export const typeContentsCovers = {
  CTTY_00: 'cover-card-document',
  CTTY_01: 'cover-card-doc',
  CTTY_03: 'cover-card-video',
  CTTY_04: 'cover-card-audio',
  CTTY_05: 'cover-card-doc',
  CTTY_06: 'cover-card-link',
  CTTY_08: 'cover-card-task',
  CTTY_09: 'cover-card-quizz',
  CTTY_10: 'cover-card-task',
  CTTY_PLENO: 'cover-card-quizz',
  CTTY_13: 'cover-card-zip',
  CTTY_14: 'cover-card-task',
  CTTY_12: 'cover-card-doc',
  CTTY_20: 'cover-card-quizz',
  CTTY_20_DONE: 'cover-card-quizz-done',
  CTTY_14_DONE: 'cover-card-task-done',
  CTTY_VIDEOLESSON: 'cover-card-videolesson',
};

export const CONTENT_TYPES = {
  AUDIO: 'CTTY_04',
  VIDEO: 'CTTY_03',
  LINK: 'CTTY_06',
  IMAGE: 'CTTY_07',
  MINT: 'CTTY_MINTBLOCK',
  MINT_PAGE: 'MINT_PAGE',
  MINT_PAGE_DUAL: 'MINT_PAGE_DUAL',
  OFFICE: 'CTTY_12',
  PDF: 'CTTY_05',
  TEST: 'CTTY_09',
  QUESTION: 'CTTY_14',
  VIDEOLESSON: 'CTTY_VIDEOLESSON',
  XAPI: 'CTTY_20',
  SCORM: 'CTTY_10',
  LTI: 'CTTY_LTI',
  ZIP: 'CTTY_13',
  FIXED_LAYOUT: 'CTTY_01',
  HTML: 'CTTY_08',
  PLENO: 'CTTY_PLENO',
};

export const CONTENT_TYPES_NAMES = {
  CTTY_01: 'Fixed Layout',
  CTTY_03: 'Video',
  CTTY_04: 'Audio',
  CTTY_05: 'PDF',
  CTTY_06: 'Link',
  CTTY_07: 'Image',
  CTTY_08: 'Interactive',
  CTTY_09: 'Quizz',
  CTTY_10: 'Scorm',
  CTTY_13: 'ZIP',
  CTTY_12: 'Office',
  CTTY_20: 'XAPI',
  CTTY_VIDEOLESSON: 'Videolesson',
  CTTY_14: 'Task',
  CTTY_LTI: 'LTI Content',
  TEST: 'Quizz',
  FIXED_LAYOUT: 'Fixed Layout',
  RETRO_BOOK: 'Retro book',
  MINT_LESSON: 'Mint Lesson',
  CTTY_PLENO: 'Evaluation',
};

export const FEEDBACK_QUESTION_TYPES = {
  QT_29: 'QT_29',
  QT_30: 'QT_30',
  QT_31: 'QT_31',
};

export const IS_MINT_FEEDBACK_QUESTION_TYPE = {
  EMOTIONS_CHOICE_STANDARD: 'Emotions choise - standard',
  RATING: 'Rating',
  ADAPTATIVE_CHOICE: 'Adaptative choice',
};

export function getIdTypeContent(id) {
  let idValue = '';
  for (let type in typeContentsIcons) {
    if (typeContentsIcons[type] === id) {
      idValue = type;
      break;
    }
  }

  return idValue;
}

export const lessonType = {
  online: {
    text: 'Online',
    icon: 'online',
    value: 'online',
  },
  onsite: {
    text: 'Onsite',
    icon: 'onsite',
    value: 'onsite',
  },
};

export const weekdays = [
  { name: 'monday', id: 'monday' },
  { name: 'tuesday', id: 'tuesday' },
  { name: 'wednesday', id: 'wednesday' },
  { name: 'thursday', id: 'thursday' },
  { name: 'friday', id: 'friday' },
  { name: 'saturday', id: 'saturday' },
  { name: 'sunday', id: 'sunday' },
];

export const devicesIcon = {
  desktop: 'desktop',
  tablet: 'tablet',
  smartphone: 'device',
};

export const licenseType = {
  personal: 'LICENSE_PERSONAL',
  school: 'SCHOOL_GROUP',
};

export const role = {
  student: 'R01',
  teacher: 'R02',
};

export const studentStreamType = {
  private: 'private',
  onlyComment: 'onlyComment',
  postAndComment: 'postAndComment',
};

export const EMBED_FROM = {
  program: 'program',
  unit: 'unit',
  lesson: 'lesson',
  activity: 'activity',
};

export const CLIENT = {
  TANGERINE: 'TANGERINE',
  EDELVIVES: 'EDELVIVES_DIGITAL_PLUS',
  MACMILLAN: 'MACMILLAN',
  SANTILLANA_ALFA: 'SANTILLANA_ALFA',
  SANTILLANA_UNOI: 'SANTILLANA_UNOI',
  SANTILLANA_INTEGRATIONS: '9d9f77ae-6747-42a5-a5f1-1c67e2a5a878',
  GOTITBYME: 'GOTITBYME',
  MASTER: 'master',
  MASTER_DEMO: 'b372c122-0bda-4546-8b38-f023a9edf8b3',
  SANTILLANA_DEMO: '71bfaecf-c8d8-40dd-b297-35bca1acce82',
  TINTA_FRESCA: '2af56435-2961-483e-8e43-cafafd1bb73f',
  SANTILLANA_PILOTO: 'a85e3e54-9c9a-4be0-b9c2-f519c34c2964',
  SANTILLANA_COLOMBIA_DEMO: '6d18d473-53ac-45ac-91e2-e6335918b97f',
  SANTILLANA_BRASIL_DEMO: 'f5cdff6c-f99d-450e-8454-5fa0dee78268',
  SANTILLANA_BRASIL_COMPARTILHA: 'd22cfcb8-9f05-4c11-a635-2414dd87c745',
  MULTITUDE: '76b1a97e-7448-4b98-b673-14636e81b271',
  SANTILLANA_BRASIL_UNOI_ON_PREM: '7243c7ca-5378-4a14-b011-72170f490afa',
  SANTILLANA_BRASIL_COMPARTILHA_ON_PREM: 'b53e0ff6-7ac5-475b-9982-228b91c71a2d',
  SUMUM_CAMPUS: '6b85196f-0f6c-4fb7-a5ff-646bd4edc559',
  SUMUN_CAMPUS_BRASIL: 'f1dcd242-7ae1-4b4b-9e0b-9c4596421306',
  SANTILLANA_UNOI_MEXICO: 'a85e3e54-9c9a-4be0-b9c2-f519c34c2964',
  BRUNO: '4a97d934-4ec0-4f28-91f8-03c835f0aac5',
};

export const SANTILLANA_ALFA = 'proyectoalfa.santillana';

export const BANNER_FORM_IMAGE = {
  [CLIENT.GOTITBYME]: 'https://gotitbyme-prod-content.s3.eu-central-1.amazonaws.com/c3975d40-0dea-11ef-bb6e-8fc4bd3c83f2/Banner%20Crear%20Clase.png',
  [CLIENT.SANTILLANA_DEMO]: 'https://santillana-demo-prod-content.s3.us-east-1.amazonaws.com/dccfe5e0-f42e-11ef-84ac-25d492ffdb3b/banner_programa-pro.png',
  [CLIENT.SANTILLANA_PILOTO]: 'https://santillana-piloto-prod-content.s3.us-east-1.amazonaws.com/225f5cd0-f42f-11ef-84ac-25d492ffdb3b/banner_programa-pro.png',
  [CLIENT.SANTILLANA_COLOMBIA_DEMO]:
    'https://santillana-colombia-demo-prod-content.s3.us-east-1.amazonaws.com/6d18d473-53ac-45ac-91e2-e6335918b97f/banner_programa-pro.png',
  [CLIENT.SANTILLANA_COLOMBIA_DEMO]:
    'https://santillana-integrations-prod-content.s3.us-east-1.amazonaws.com/9d9f77ae-6747-42a5-a5f1-1c67e2a5a878/banner_programa-pro.png',
};

export const KANBAN_BACKGROUND_IMAGE = {
  GOTITBYME: 'https://gotitbyme-prod-content.s3.eu-central-1.amazonaws.com/c3f279e0-66b0-11ef-8e06-057a2779e67f/kanban-bg.png',
};

export const LESSON_TYPES_IDS = {
  TEACHER: 'teacher',
  MINT: 'mint',
  POWER: 'power',
};

export const LESSON_TYPES = [
  {
    name: 'lesson:Classic',
    id: LESSON_TYPES_IDS.TEACHER,
  },
  {
    name: 'lesson:Mint',
    id: LESSON_TYPES_IDS.MINT,
  },
  {
    name: 'lesson:Power',
    id: LESSON_TYPES_IDS.POWER,
  },
];

export const AMPLITUDE_EVENT = {
  START: 'START',
  SEND_MESSAGE: 'SEND MESSAGE',
  SEND_COMMENT: 'SEND COMMENT',
  PROJECT_LESSON: 'PROJECT LESSON',
  REMOTE_DEVICE_CONNECTED: 'REMOTE DEVICE CONNECTED',
  PERSONALIZE_PROGRAM: 'PERSONALIZE PROGRAM',
  EDIT_EDITORIAL_LESSON: 'EDIT EDITORIAL LESSON',
  CREATE_NEW_LESSON: 'CREATE NEW LESSON',
  CREATE_NEW_UNIT: 'CREATE NEW UNIT',
  REVIEW_TASK: 'REVIEW TASK',
  REVIEW_MATERIAL: 'REVIEW MATERIAL',
  ASSESSMENT_FEEDBACK: 'ASSESSMENT FEEDBACK',
  TASK_FEEDBACK: 'TASK FEEDBACK',
  OPEN_CONTENT: 'OPEN CONTENT',
  SET_DELIVER_DATE: 'SET DELIVER DATE',
  OPEN_GRADES: 'OPEN GRADES',
  MINT_HIGHLIGHT: 'MINT HIGHLIGHT',
  SHARE_GOOGLE_CLASSROOM: 'SHARE ON GOOGLE CLASSROOM',
  ANSWER_ACTIVITY: 'ANSWER ACTIVITY',
  DOWNLOAD_DESKTOP_APP: 'DOWNLOAD DESKTOP APP',
  OPEN_TODO: 'OPEN TODO',
  OPEN_IMMERSIVE_READER: 'OPEN IMMERSIVE READER',
  OPEN_LESSON: 'OPEN LESSON',
  OPEN_LESSON_ITEM: 'OPEN LESSON ITEM',
  HIGHLIGHTER: 'HIGHLIGHTER',
  STUDENTS_VIEW_RESULTS: 'STUDENTS VIEW RESULTS',
  VIEW_TASK_RESULTS: 'VIEW TASK RESULTS',
  HOME_LIBRARY: 'HOME LIBRARY',
  OPEN_COURSE: 'OPEN COURSE',
  CHANGE_LANGUAGE: 'CHANGE LANGUAGE',
  CREATE_MATERIAL: 'CREATE MATERIAL',
  CREATE_ACTIVITY: 'CREATE ACTIVITY',
  ADD_ACTIVITY_FROM_LIBRARY: 'ADD ACTIVITY FROM LIBRARY',
  ADD_MINT_BLOCK: 'ADD MINT BLOCK',
  CREATE_VIDEOLESSON: 'CREATE VIDEOLESSON',
  CREATE_EVALUATION: 'CREATE EVALUATION',
  CREATE_QUIZ: 'CREATE QUIZ',
  CREATE_TASK: 'CREATE TASK',
  PAGINATION_OPEN_WIDGET: 'OPEN PAGINATION WIDGET',
  PAGINATION_GO_TO_PAGE: 'PAGINATION GO TO PAGE',
  PAGINATION_OPEN_BOOK: 'PAGINATION OPEN BOOK',
  DO_TASK: 'DO TASK',
  OPEN_USERS_CLASSROOM: 'OPEN USERS CLASSROOM',
  IMPORT_FROM_CLASSROOM: 'IMPORT FROM CLASSROOM',
  CLICK_IMPORT_FROM_CLASSROOM: 'CLICK IMPORT FROM CLASSROOM',
  CREATE_EMBED_LINK: 'CREATE EMBED LINK',
  CREATE_LINK: 'CREATE LINK',
  CREATE_FEEDBACK_AI: 'CREATE FEEDBACK AI',
  CREATE_ACTIVITY_AI: 'CREATE ACTIVITY AI',
  CREATE_MODEL_AI: 'CREATE MODEL AI',
  SHOW_LESSON_ITEM: 'SHOW LESSON ITEM',
  OPEN_HOMEPAGE: 'OPEN HOMEPAGE',
  OPEN_SESSION: 'OPEN SESSION',
  OPEN_KANBAN: 'OPEN KANBAN',
  OPEN_CALENDAR: 'OPEN CALENDAR',
  MOVE_SESSION: 'MOVE SESSION',
  GRADE_STUDENT: 'GRADE STUDENT',
  PUBLISH_GRADE: 'PUBLISH GRADE',
  UNPUBLISH_GRADE: 'UNPUBLISH GRADE',
  LOGIN_FAILED: 'LOGIN FAILED',
  SEND_WALL_MESSAGE: 'SEND WALL MESSAGE',
  SEND_WALL_COMMENT: 'SEND WALL COMMENT',
  OPEN_CLASS_RESOURCES: 'OPEN CLASS RESOURCES',
  OPEN_MODULE_RESOURCES: 'OPEN MODULE RESOURCES',
  OPEN_SESSION_RESOURCES: 'OPEN SESSION RESOURCES',
  GRADE_TASK: 'GRADE TASK',
  SEND_CLASS_MESSAGE: 'SEND CLASS MESSAGE',
  CREATE_SECTION: 'CREATE SECTION',
  SAVE_COURSE_CONFIG: 'SAVE COURSE CONFIG',
  OPEN_COURSE_CONFIG: 'OPEN COURSE CONFIG',
  OPEN_GRADEBOOK: 'OPEN GRADEBOOK',
};

export const STUDENT_AGES = {
  ey1: 3,
  ey2: 4,
  ey4: 6,
  ey5: 7,
  ey6: 8,
  ey7: 9,
  ey8: 10,
  ey9: 11,
  ey10: 12,
  ey11: 13,
  ey12: 14,
  ey13: 15,
  ey14: 16,
  ey15: 17,
  'ey-es-01': 3,
  'ey-es-02': 4,
  'ey-es-03': 5,
  'ey-es-04': 6,
  'ey-es-05': 7,
  'ey-es-06': 8,
  'ey-es-07': 9,
  'ey-es-08': 10,
  'ey-es-09': 11,
  'ey-es-10': 12,
  'ey-es-11': 13,
  'ey-es-12': 14,
  'ey-es-13': 15,
  'ey-es-90': 16,
  'ey-es-91': 17,
  'ey-ar-01': 3,
  'ey-ar-02': 4,
  'ey-ar-03': 5,
  'ey-ar-04': 6,
  'ey-ar-05': 7,
  'ey-ar-06': 8,
  'ey-ar-07': 9,
  'ey-ar-08': 10,
  'ey-ar-09': 11,
  'ey-ar-10': 12,
  'ey-ar-11': 13,
  'ey-ar-12': 14,
  'ey-ar-13': 15,
  'ey-ar-90': 16,
  'ey-ar-91': 17,
};

export const AI_ASSISTANT_SCOPE = {
  HOME: 'HOME',
  COURSE: 'COURSE',
  LESSON: 'LESSON',
  XAPI: 'XAPI',
};

export const AI_ASSISTANT_DIALOG_TYPE = {
  TEXT: 'TEXT',
  QUESTION: 'QUESTION',
};
export const VIDEOLESSON_EMPTY = {
  id: '',
  url: '',
  thumbnailUrl: '',
  duration: '',
  title: '',
  type: '',
  sections: [],
  references: [],
  questions: {},
  preferences: { allowSkipAhead: true, allowRepeatQuestion: true },
};

export const FEATURE_FLAGS = {
  SHOW_IMMERSIVE_READER: 'showImmersiveReader',
  SHOW_LEMONADE_FEEDBACK_GENERATOR: 'showLemonadeFeedbackGenerator',
  QUESTION_GENERATED_WITH_AI: 'questionsGeneratedWithAi',
  SHOW_CREATE_VIDEOLESSON: 'showCreateVideolesson',
  FEEDBACK_GENERATED_WITH_AI: 'feedbackGeneratedWithAi',
  SHOW_CUSTOM_AVATAR: 'showPersonalizeAvatar',
  ALLOW_MOVE_SESSIONS: 'allowMoveCalendarSessions',
  SHOW_POWER_LESSON: 'showPowerLesson',
  SHOW_SELECT_TYPE_LESSON: 'showSelectTypeLesson',
  SHOW_PROGRAM_RESOURCES: 'showProgramResources',
  SHOW_INFANTILE_01: 'theme-infantile-01',
  IS_ENABLED_MIGRATE_TO_NUTRIENT: 'isEnabledMigrateToNutrient',
  ENABLE_ROW_COLUMN_LAYOUT: 'enableRowColumnLayout',
  IS_SINGLE_POST: 'isSinglePost',
  ENABLE_POPUPS: 'enablePopups',
  ENABLE_TEXT_TOOLTIPS: 'enableTextTooltips',
  MINT_HIDE_OPTION_AUDIOS_POST: 'mintHideOptionAudiosPost',
  MINT_HIDE_OPTION_PDF_PAGES: 'mintHideOptionPdfPages',
  MINT_SHOW_ASSISTANT_EDITOR: 'mintShowAssistantEditor',
  MINT_SHOW_AUDIOS_MINT: 'showAudiosMint',
  MINT_ENABLE_ROW_COLUMN_LAYOUT: 'enableRowColumnLayout',
  MINT_IS_SINGLE_POST: 'isSinglePost',
  MINT_ENABLE_POPUPS: 'enablePopups',
  MINT_ENABLE_TEXT_TOOLTIPS: 'enableTextTooltips',
  MINT_ENABLE_BACKGROUND_GRADIENT: 'enableBackgroundGradient',
};

export const TNG_TEMPLATES = {
  VANILLA: 'vanilla',
  UNOI: 'unoi',
  COMPONENTS: 'components',
  STEAM: 'steam',
  CUSTOMIZABLE: 'personalizable',
};

export const MAP_TYPES = {
  SPAIN: 'map_es',
};

export const systemRequirements = {
  es: '<div class="login-form__system-requirements-text"><ol><h3><li> Plataforma web (navegadores soportados)</h3> <ul><li>- Google Chrome (versiones actuales y dos versiones anteriores)</li><li>- Mozilla Firefox (versiones actuales y dos versiones anteriores)</li><li>- Microsoft Edge (versiones actuales y dos versiones anteriores)</li><li>- Safari (versiones actuales y dos versiones anteriores)</li></ul></li></ol><ol><li><strong>iOS:</strong> <ul><li> Versión mínima: 18 </li></ul> </li> <li><strong>Android:</strong>  <ul><li> Versión mínima: 15 </li></ul></li></li></ul></li></ol></div>',
  en: '<div class="login-form__system-requirements-text"><ol><h3><li> Web Application (supported browsers)</h3> <ul><li>- Google Chrome (current and two previous versions)</li><li>- Mozilla Firefox (current and two previous versions)</li><li>- Microsoft Edge (current and two previous versions)</li><li>- Safari (current and two previous versions)</li></ul></li></ol><ol><li><strong>iOS:</strong> <ul><li> Minimum version: 18 </li></ul> </li> <li><strong>Android:</strong>  <ul><li> Minimum version: 15 </li></ul></li></li></ul></li></ol></div>',
  pt: '<div class="login-form__system-requirements-text"><ol><h3><li> Plataforma web (navegadores suportados)</h3> <ul><li>- Google Chrome (versão atual e duas versões anteriores)</li><li>- Mozilla Firefox (versão atual e duas versões anteriores)</li><li>- Microsoft Edge (versão atual e duas versões anteriores)</li><li>- Safari (versão atual e duas versões anteriores)</li></ul></li></ol><ol><li><strong>iOS:</strong> <ul><li> Versão mínima: 18 </li></ul> </li> <li><strong>Android:</strong>  <ul><li> Versão mínima: 15 </li></ul></li></li></ul></li></ol></div>',
};

export const systemRequirementsWithApps = {
  es: '<div class="login-form__system-requirements-text"><ol><h3><li> Plataforma web (navegadores soportados)</h3> <ul><li>- Google Chrome (versiones actuales y anteriores)</li><li>- Mozilla Firefox (versiones actuales y anteriores)</li><li>- Microsoft Edge (versiones actuales y anteriores)</li><li>- Safari (versiones actuales y anteriores)</li></ul></li></ol><ol><h3><li>APPS</h3><ul><li><strong>Escritorio</strong> <ul> <li> <strong> - Mac:</strong> <ul><li> Versión mínima: macOS 10.12 </li><li> Memoria RAM: 4GB </li></ul></li><li><strong>- Windows:</strong> <ul><li> Versión mínima: Windows 7 (deseable 10) </li> <li> Memoria RAM: 4GB </li></ul></li><li><strong>- Linux:</strong> <ul><li> Versión mínima: Ubuntu 14.04.4 LTS (deseable Ubuntu 14.04.5 LTS) </li><li> Memoria RAM: 4GB </li></ul></li></ul><li><strong>iOS:</strong> <ul><li> Versión mínima: 18 </li></ul> </li> <li><strong>Android:</strong>  <ul><li> Versión mínima: 15 </li></ul></li></li></ul></li></ol></div>',
  en: '<div class="login-form__system-requirements-text"><ol><h3><li> Web Application (supported browsers)</h3> <ul><li>- Google Chrome (current and previous versions)</li><li>- Mozilla Firefox (current and previous versions)</li><li>- Microsoft Edge (current and previous versions)</li><li>- Safari (current and previous versions)</li></ul></li></ol><ol><h3><li>APPS</h3><ul><li><strong>Desktop</strong> <ul> <li> <strong> - Mac:</strong> <ul><li> Minimum requirements: macOS 10.12 </li><li> RAM: 4GB </li></ul></li><li><strong>- Windows:</strong> <ul><li> Minimum requirements: Windows 7 (deseable 10) </li> <li> RAM: 4GB </li></ul></li><li><strong>- Linux:</strong> <ul><li> Minimum requirements: Ubuntu 14.04.4 LTS (deseable Ubuntu 14.04.5 LTS) </li><li> RAM: 4GB </li></ul></li></ul><li><strong>iOS:</strong> <ul><li> Minimum version: 18 </li></ul> </li> <li><strong>Android:</strong>  <ul><li> Minimum version: 15 </li></ul></li></li></ul></li></ol></div>',
  pt: '<div class="login-form__system-requirements-text"><ol><h3><li> Plataforma web (navegadores suportados)</h3> <ul><li>- Google Chrome (versões atuais e anteriores)</li><li>- Mozilla Firefox (versões atuais e anteriores)</li><li>- Microsoft Edge (versões atuais e anteriores)</li><li>- Safari (versões atuais e anteriores)</li></ul></li></ol><ol><h3><li>APPS</h3><ul><li><strong>Desktop</strong> <ul> <li> <strong> - Mac:</strong> <ul><li> Versão mínima: macOS 10.12 </li><li> Memória RAM: 4GB </li></ul></li><li><strong>- Windows:</strong> <ul><li> Versão mínima: Windows 7 (recomendado 10) </li> <li> Memória RAM: 4GB </li></ul></li><li><strong>- Linux:</strong> <ul><li> Versão mínima: Ubuntu 14.04.4 LTS (recomendado Ubuntu 14.04.5 LTS) </li><li> Memória RAM: 4GB </li></ul></li></ul><li><strong>iOS:</strong> <ul><li> Versão mínima: 18 </li></ul> </li> <li><strong>Android:</strong>  <ul><li> Versão mínima: 15 </li></ul></li></li></ul></li></ol></div>',
};

export const PDF_ENGINE = {
  NUTRIENT: 'nutrient',
  PDFTRON: 'pdftron',
  NUTRIENT_STANDALONE: 'nutrient-standalone',
};
